import script from "./HomeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeIcon.vue?vue&type=script&setup=true&lang=js"

import "./HomeIcon.vue?vue&type=style&index=0&id=a95c6e0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a95c6e0c"]])

export default __exports__